import React, { useState } from 'react';

type Member = {
  id: number;
  name: string;
  email: string;
  business_Or_Employer: string;
  applied_On: string;
  status: string;
};

interface DeleteMemberModalProps {
  member: Member | null;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (memberId: number) => void;
}

const DeleteMemberModal: React.FC<DeleteMemberModalProps> = ({ member, isOpen, onClose, onConfirm }) => {
  const [loading, setLoading] = useState(false);

  if (!isOpen || !member) return null;

  const handleDelete = async () => {
    setLoading(true);
    try {
      onConfirm(member.id);
      onClose();
    } catch (err) {
      console.error(err);
      // You could add error handling here if needed
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dashboard-modal-backdrop">
      <div className="dashboard-modal dashboard-modal-delete-confirm">
        <button 
          className="dashboard-modal-close" 
          aria-label="Close" 
          onClick={onClose}
          disabled={loading}
        >
          &times;
        </button>
        <div className="dashboard-modal-delete-x">
          <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
            <circle cx="28" cy="28" r="26" stroke="#e74c3c" strokeWidth="3" fill="none" />
            <path d="M19 19l18 18M37 19l-18 18" stroke="#e74c3c" strokeWidth="3" strokeLinecap="round" />
          </svg>
        </div>
        <div className="dashboard-modal-delete-title">Are you sure?</div>
        <div className="dashboard-modal-delete-msg">
          <div className="dashboard-modal-delete-details">
            <b>Name:</b> {member.name}
          </div>
          <div className="dashboard-modal-delete-details">
            <b>Email:</b> {member.email}
          </div>
          <div className="dashboard-modal-delete-details">
            <b>Business/Employer:</b> {member.business_Or_Employer}
          </div>
        </div>
        <div className="dashboard-modal-actions dashboard-modal-delete-actions">
          <button 
            className="dashboard-modal-cancel" 
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button 
            className="dashboard-modal-save dashboard-modal-delete-btn" 
            onClick={handleDelete}
            disabled={loading}
          >
            {loading ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteMemberModal; 